type Period = { day: string; values: { [key: string]: number } }

/**
 * Compact mobile stand-in for a stacked time-series chart: each period (day /
 * week / month) as a row with a proportional bar and the summed total. Takes the
 * same `{ day, values }` data the chart is grouped into, so it's a drop-in swap.
 */
export function PeriodTrendList({ periods, title }: { periods: Period[]; title?: string }) {
  const rows = periods
    .map((p) => ({
      label: p.day,
      count: Object.values(p.values).reduce((sum, v) => sum + Number(v || 0), 0),
    }))
    .filter((r) => r.label)

  if (rows.length === 0) return null

  const max = Math.max(...rows.map((r) => r.count), 1)

  return (
    <div className="rounded-lg border border-default">
      {title && <div className="border-b border-subtle px-4 py-3 text-body-sm font-medium text-default">{title}</div>}
      <div className="flex flex-col divide-y divide-subtle">
        {rows.map((row) => (
          <div key={row.label} className="flex items-center gap-3 px-4 py-2.5">
            <span className="w-24 shrink-0 text-body-sm text-subtle">{row.label}</span>
            <div className="h-2 flex-1 overflow-hidden rounded-full bg-surface-muted">
              <div
                className="h-full rounded-full bg-blue-500"
                style={{ width: `${max > 0 ? Math.max((row.count / max) * 100, row.count > 0 ? 4 : 0) : 0}%` }}
              />
            </div>
            <span className="w-12 shrink-0 text-right text-body-sm font-semibold tabular-nums text-strong">
              {row.count.toLocaleString(`en-US`)}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
